export default __webpack_public_path__ + "static/media/login.e81b168d.png";